import VueCharts from 'vue-chartjs';
import moment from 'moment';

const TICK_INTERVAL = 7;
const Y_TICK_INTERVAL = 5;

export default {
    extends: VueCharts.Line,
    mixins: [VueCharts.mixins.reactiveProp],
    props: ['chartData', 'interval', 'created'],
    data() {
        return {
            options: {
                responsive: true,
                maintainAspectRatio: false,
                tooltips: {
                    position: 'nearest',
                    mode: 'index',
                    intersect: false,
                    callbacks: {
                        title() {
                            return '';
                        },
                        label(tooltipItem, data) {

                            let label = data.datasets[tooltipItem.datasetIndex].label || '';
                            if (label) {
                                label += `: ${tooltipItem.yLabel}`;
                                label += data.t.unit_request_count;
                            }
                            return label;
                        },
                        footer(tooltipItem, data) {
                            if (typeof data.labels[tooltipItem[0].index] === 'object') {
                                if (data.t.interval === '1d') {
                                    return data.labels[tooltipItem[0].index][0];
                                }
                                return data.labels[tooltipItem[0].index].join(' ');
                            }
                            return data.labels[tooltipItem[0].index];
                        },
                    },
                    bodySpacing: 5,
                    footerSpacing: 7,
                },
                scales: {
                    xAxes: [{
                        ticks: {
                            maxRotation: 0,
                            minRotation: 0,
                            autoSkip: true,
                            maxTicksLimit: TICK_INTERVAL,
                            callback(value, index, values) {
                                if (value.length === 2) {
                                    if (this.chart.data.t.interval === '1d') {
                                        return moment(value[0]).format('MM-DD');
                                    }
                                    const tm = value[1].split(':');
                                    tm.pop();
                                    return [moment(value[0]).format('MM-DD'), tm.join(':')];
                                }
                                if (this.chart.data.t.interval === '1d') {
                                    return moment(value).format('MM-DD');
                                }
                                return moment(value).format('MM-DD HH:mm');
                            },
                        },
                    }],
                    yAxes: [{
                        fill: false,
                        display: true,
                        ticks: {
                            min: 0,
                            maxTicksLimit: Y_TICK_INTERVAL,
                            callback(value, index, values) {
                                if (Math.floor(value) === value) {
                                    return value;
                                }
                            },
                        },
                    }],
                },
            },
            dataWork: [],
        };
    },
    mounted() {
        this.addPlugin({
            beforeInit(chart) {
                chart.data.labels.forEach((e, i, a) => {
                    e = moment(e).format('YYYY-MM-DD HH:mm:ss');
                    if (/\s/.test(e)) {
                        a[i] = e.split(/\s/);
                    }
                });
            },
        });
    },
    methods: {
        initialize() {
            this.dataWork = [];
            this.makeDataWork();
            // this.paddingData();
            this.loadChart();
        },
        makeDataWork() {
            const helperColor = Chart.helpers.color;
            const colors = [
                '#3366CC',
                '#DC3912',
                '#FF9900',
                '#109618',
                '#990099',
                '#990099',
                '#3B3EAC',
                '#0099C6',
                '#DD4477',
                '#66AA00',
                '#B82E2E',
                '#316395',
                '#994499',
                '#22AA99',
                '#AAAA11',
                '#6633CC',
                '#E67300',
                '#8B0707',
                '#329262',
                '#5574A6',
                '#3B3EAC',
            ];
            const { length } = this.chartData.legends;
            if (length > 0) {
                for (let i = 0; i < length; i += 1) {
                    const legend = this.chartData.legends[i];
                    let curColor;
                    if (typeof colors[i] !== 'undefined') {
                        curColor = colors[i];
                    } else {
                        curColor = '#000';
                    }
                    const item = {
                        type: 'line',
                        fill: false,
                        pointRadius: 0,
                        pointHitRadius: 3,
                        pointHoverRadius: 3,
                        label: legend,
                        backgroundColor: helperColor(curColor).alpha(1).rgbString(),
                        borderColor: curColor,
                        borderWidth: 2,
                        data: this.chartData.results[legend],
                    };
                    this.dataWork.push(item);
                }
            }
        },
        loadChart() {
            this.renderChart({
                t: {
                    unit_user_count: this.$t('words.unit_user_count'),
                    unit_request_count: this.$t('words.unit_request_count'),
                    interval: this.interval,
                },
                labels: this.chartData.labels,
                datasets: this.dataWork,

            }, this.options);
        },
        paddingData() {
            const { legendLength } = this.chartData.legends;
            if (legendLength > 0 && this.chartData.labels.length > 0) {
                let zeroValue = true;
                for (let i = 0; i < legendLength; i += 1) {
                    const legend = this.chartData.legends[i];
                    if (this.chartData.results[legend][0] !== 0) {
                        zeroValue = false;
                        break;
                    }
                }
                if (zeroValue) {
                    // remove first item
                    this.chartData.labels = _.drop(this.chartData.labels, 1);
                    for (let i = 0; i < legendLength; i += 1) {
                        const legend = this.chartData.legends[i];
                        this.chartData.results[legend] = _.drop(this.chartData.results[legend], 1);
                    }
                }
            }
            if (legendLength > 0 && this.chartData.labels.length > 0) {
                const lastIndex = this.chartData.labels.length - 1;
                let zeroValue = true;
                for (let i = 0; i < legendLength; i += 1) {
                    const legend = this.chartData.legends[i];
                    if (this.chartData.results[legend][lastIndex] !== 0) {
                        zeroValue = false;
                        break;
                    }
                }
                if (zeroValue) {
                    // remove last item
                    this.chartData.labels = _.dropRight(this.chartData.labels, 1);
                    for (let i = 0; i < legendLength; i += 1) {
                        const legend = this.chartData.legends[i];
                        this.chartData.results[legend] = _.dropRight(this.chartData.results[legend], 1);
                    }
                }
            }
        },
    },
    watch: {
        // created(newValue, oldValue) {
        //     this.paddingData();
        //     this.loadChart();
        // },
    },
};
